@if (banner(); as b) {
  <div class="filter-banner" @slide role="status" aria-live="polite" [matTooltip]="b.text">
    <mat-icon class="filter-banner__icon">filter_alt</mat-icon>
    <span class="filter-banner__text">{{ b.text }}</span>
  </div>
}
